import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "broken_active",
  "use": "broken_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"broken_active\"><path d=\"M10 1a8 8 0 0 1 8 8v8.147a1 1 0 0 1-1.858.514L15 15.757l-1.793 1.793a1 1 0 0 1-1.415 0L10 15.757 8.207 17.55a1 1 0 0 1-1.415 0L5 15.757l-1.143 1.905A1 1 0 0 1 2 17.148V9a8 8 0 0 1 8-8Zm3 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM7 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM7 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol